<div class="row">

    <div class="col-xl-8">
        <div class="profile">
            <h2>profile</h2>
            <table class="table" *ngIf="data">
                <tr>
                    <th>user id</th>
                    <td>{{data?.username}}</td>
                </tr>
                <tr>
                    <th>available chips</th>
                    <td>{{data?.available_balance}}</td>
                </tr>
                <tr>
                    <th>exposure</th>
                    <td>{{data?.expose}}</td>
                </tr>
                <tr>
                    <th>total chips</th>
                    <td>{{data?.balance}}</td>
                </tr>
                <tr>
                    <th>profit</th>
                    <td><span [ngClass]="data.pl >= 0 ? 'profit' : 'loss'">{{data?.pl}}</span></td>
                </tr>
               
            </table>
            <div *ngIf="!data">
                <app-loader class="no-overlay"></app-loader>
            </div>
        </div> <!-- end card-->

        <!-- inner footer -->
        <div class="row">
            <div class="col-md-12">
                <div class="inner-footer">
                    <div class="support-wrap">
                        <dl class="support-mail">
                            <a class="rules-btn-home">Privacy Policy</a>
                            <a class="rules-btn-home arrow">KYC</a>
                            <a class="rules-btn-home arrow">Terms and Conditions</a>
                            <a class="rules-btn-home arrow">Rules and Regulations</a>
                            <a class="rules-btn-home arrow">Responsible Gambling</a>
                        </dl>
                    </div>
                </div>
            </div>
        </div>
        <!-- inner footer -->

    </div> <!-- end col -->

    <div class="col-xl-4">
        <div class="openBets">
            <h2>open bets</h2>
        </div> <!-- end card-->
    </div> <!-- end col -->

</div>